import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface ChipProps {
  tone?: 'default' | 'ok' | 'warn' | 'alert' | 'info' | 'ghost' | 'active';
  dot?: boolean;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Chip({ tone = 'default', dot, children, className, onClick }: ChipProps) {
  // Quando è cliccabile diventa un <button> reale: focusabile da tastiera,
  // attivabile con Enter/Space, annunciato come pulsante dagli screen reader.
  if (onClick) {
    return (
      <button
        type="button"
        className={cn('chip chip-btn', tone !== 'default' && tone, className)}
        onClick={onClick}
      >
        {dot && <span className="chip-dot" />}
        {children}
      </button>
    );
  }
  return (
    <span className={cn('chip', tone !== 'default' && tone, className)}>
      {dot && <span className="chip-dot" />}
      {children}
    </span>
  );
}

export function statusTone(status: string): ChipProps['tone'] {
  const s = status.toUpperCase();
  if (['ATTIVO', 'IN_CORSO', 'PAGATA', 'DONE', 'APPROVATA', 'ASSUNTO'].includes(s)) return 'ok';
  if (['REVISIONE', 'REVIEW', 'IN_VALUTAZIONE', 'COLLOQUIO_FISSATO', 'EMESSA', 'INVIATA'].includes(s)) return 'warn';
  if (['SCADUTA', 'BLOCKED', 'ALERT', 'RIFIUTATA'].includes(s)) return 'alert';
  if (['PREVENTIVO', 'LEAD', 'TODO', 'BOZZA'].includes(s)) return 'info';
  if (['IN_PAUSA', 'CHIUSO'].includes(s)) return 'ghost';
  return 'default';
}
